module.exports = __webpack_public_path__ + "img/list-ul.811bf059.svg";